import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextInput from '../../components/TextInput';
import TextAreaInput from '../../components/TextAreaInput';
import SelectInput from '../../components/SelectInput';
import CheckboxInput from '../../components/CheckboxInput';
import Button from '../../components/Button';
import SkeletonLoader from '../../components/SkeletonLoader';
import headerFooterApi from '../../api/headerFooterApi';
import { useToast } from '../../contexts/ToastContext';
import { ROUTES, HEADER_FOOTER_POSITIONS } from '../../constants';

const AddHeaderFooter = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    code: '',
    is_active: 1,
    position: 'header',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
    });
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setValidationErrors({});

    try {
      await headerFooterApi.createHeaderFooter(formData);
      addToast('Header/Footer code created successfully!', 'success');
      navigate(ROUTES.HEADER_FOOTER);
    } catch (err) {
      console.error('Failed to add header/footer code:', err);
      if (err.response && err.response.status === 422) {
        setValidationErrors(err.response.data.errors || {});
        addToast(err.response.data.message || 'Validation failed. Please check your input.', 'error');
      } else {
        addToast(err.response?.data?.message || 'Failed to add header/footer code. Please try again.', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  const positionOptions = HEADER_FOOTER_POSITIONS;

  return (
    <div className="p-6 bg-gray-800 rounded-lg shadow-md text-text-white">
      <h1 className="text-3xl font-bold mb-6">Add New Header/Footer Code</h1>
      {loading ? (
        <SkeletonLoader type="form" />
      ) : (
        <form onSubmit={handleSubmit}>
          <TextInput
            label="Name"
            name="name"
            id="name"
            value={formData.name}
            onChange={handleChange}
            required={true}
            placeholder="Name"
            error={validationErrors?.name?.[0]}
          />
          <TextAreaInput
            label="Code"
            name="code"
            id="code"
            value={formData.code}
            onChange={handleChange}
            required={true}
            rows={6}
            className="font-mono"
            placeholder="Code"
            error={validationErrors?.code?.[0]}
          />
          <SelectInput
            label="Position"
            name="position"
            id="position"
            value={formData.position}
            onChange={handleChange}
            options={positionOptions}
            required={true}
            error={validationErrors?.position?.[0]}
          />
          <CheckboxInput
              label="Active"
              name="is_active"
              id="is_active"
              checked={formData.is_active}
              onChange={handleChange}
          />
          <div className="flex items-center justify-between mt-6">
            <Button
              type="submit"
              className="bg-accent-red hover:bg-red-700 text-white"
              loading={loading}
            >
              Add Code
            </Button>
            <Button
              type="button"
              onClick={() => navigate(ROUTES.HEADER_FOOTER)}
              className="bg-gray-500 hover:bg-gray-600 text-white"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddHeaderFooter;